import {Role, User} from '../../graphql/auth';
import userRoleLevel from '../../utils/userRoleLevel';

let rules = {
  'role_higher_level': (user: User | null, data?: {role: Role}): boolean => {
    if(!user) return false;  //need to be logged in
    if(!data || !data.role) return true;//if no role passed in, we pass check.
    if(data.role.level === undefined || data.role.level === null)return false;

    return data.role.level > userRoleLevel(user);
  },
};

export const addRule = (id: string, rule: (user: any | null, data?: any) => boolean) => {
  rules = {...rules, [id]: rule }
};

export const getRule = (id: string): (user?: any, data?: any) => boolean => {
  return (rules as any)[id] as (user?: any, data?: {}) => boolean;
};